import {observer} from "mobx-react";
import { Button, Grid, Grow, Stack, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {accountStore} from "../../../Stores/AccountStore";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import * as React from "react";
import DAWAAutocomplete from "../../Form/DAWAAutocomplete";
import { useEffect, useState } from "react";

const AddressBlock = ({ register, errors, submitForm, id, name, label, watch, control}) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const [addressFromDawa,setAddressFromDawa] = useState();

    useEffect(() => {
        const fetchData = async (address) => {
            try {
                const response = await fetch(`https://api.dataforsyningen.dk/autocomplete?q=${address}`);
                const data = await response.json();
                setAddressFromDawa(data[0].forslagstekst);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData(accountStore.user.street + ", " + accountStore.user.zip);

    }, [accountStore.user.street, accountStore.user.zip]);

    const handleBlocks = (event) => {
        let isActive = !active
        setActive(isActive)
        const eventButtonContent = event.target.innerText;
        if(!!eventButtonContent){
            if (eventButtonContent.trim() === "GEM") {
                submitForm();
            }
        }

    };
    const addressRegex = /^[a-zA-Z\u00C0-\u017F0-9\s.,'-]+\s\d{4}\s[a-zA-Z\u00C0-\u017F\s]+$/;
    const [active, setActive] = React.useState(false);
    return (
        <Box>
            {active ?
                <Grow in={active}>
                    <Stack direction={{xs: 'column', sm: 'row'}} spacing={2} p={2} justifyContent="space-between"
                           alignItems="center">
                            <DAWAAutocomplete
                              maxWidth="100%"
                              fullwidth
                              defaultAddressValue={addressFromDawa}
                              watch={watch}
                              id={id}
                              control={control}
                              label="Adresse:"
                              register={register}
                              options={{
                                  required: "Påkrævet",
                                  pattern: {
                                      value: addressRegex,
                                      message: "Indtast og vælg en gyldig adresse."
                                  }
                              }}
                              errors={errors}/>
                        <Stack direction={{xs: 'row', sm: 'column'}} spacing={1}
                               width={matches ? "100%" : undefined} justifyContent="space-between"
                               alignItems="center">
                            <Button name={name + "Cancel"}
                                    variant="contained"
                                    onClick={(event) => handleBlocks(event, name)}
                                    fullWidth={!matches}
                                    color="jagtred">
                                Annuller
                            </Button>
                            <Button name={name + "Save"}
                                    onClick={(event) => handleBlocks(event, name)}
                                    fullWidth={!matches}
                                    variant="contained"
                                    color="jagtyellow">
                                Gem
                            </Button>
                        </Stack>
                    </Stack>
                </Grow>
                :
                matches ?
                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: "3em",
                        padding: 3
                    }}>
                        <Stack spacing={1}>
                            <Typography sx={{fontWeight: 'bold'}}> {label} </Typography>
                            <Stack>
                                <Typography id="addressBlockText">{addressFromDawa}</Typography>
                            </Stack>
                        </Stack>
                        <IconButton color="jagtred" name={name + "Edit"} onClick={(event) => handleBlocks(event, name)}> <EditIcon/>
                        </IconButton>
                    </Box>
                    :
                    <Grid container direction="row" justifyContent="space-around" alignItems="center" sx={{height: "5em", padding: 3}}>
                        <Grid item sm={3}>
                        <Typography sx={{fontWeight: 'bold'}}> {label} </Typography>
                        </Grid>
                        <Grid item sm={6}>
                            <Stack>
                                <Typography id="addressBlockText">{addressFromDawa}</Typography>
                            </Stack>
                        </Grid>
                        <Grid item sm={3} sx={{textAlign: "right"}}>
                        <IconButton color="jagtred" name={name + "Edit"}
                                    onClick={(event) => handleBlocks(event, name)}><EditIcon/></IconButton>
                        </Grid>
                    </Grid>
            }
        </Box>
    )

}

export default observer(AddressBlock);